<vnm-persistent-notification
  icon="envelope-open-text"
  [dismissible]="true"
  header="invite-notification.title"
  [message]="'invite-notification.message' | translate: { inviter: record?.inviter?.fullName, course: record?.name }"
  [record]="record"
  (click)="toggleInvite()"
  (dismiss)="onDismiss()"
>
  <ng-container *ngTemplateOutlet="inviteActions"></ng-container>
</vnm-persistent-notification>
<p-dialog [(visible)]="showInvite" closeIcon="fa fa-fw fa-times" [header]="'invite-notification.title' | translate">
  <vnm-validation-errors [errors]="errors"></vnm-validation-errors>
  <p
    [innerHTML]="
      'handle-invite.dialog-message' | translate: { inviter: record?.inviter?.fullName, course: record?.name }
    "
  ></p>
  <p-footer>
    <ng-container *ngTemplateOutlet="inviteActions"></ng-container>
  </p-footer>
</p-dialog>

<ng-template #inviteActions>
  <div class="invite-actions">
    <button
      type="button"
      class="p-button-danger"
      pButton
      icon="fa fa-times"
      [label]="'app.decline' | translate"
      (click)="onHandleInvite($event, false)"
      [disabled]="submitted"
    ></button>
    <button
      type="button"
      class="p-button-success"
      pButton
      icon="fa fa-check"
      [label]="'app.accept' | translate"
      (click)="onHandleInvite($event, true)"
      [disabled]="submitted"
    ></button>
  </div>
</ng-template>
